import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { whatsappLink } from "../lib/contact";

export const CTASection = () => {
  return (
    <section
      data-testid="cta-section"
      className="relative py-16 lg:py-20 px-5 sm:px-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="max-w-7xl mx-auto relative overflow-hidden rounded-3xl bg-[rgb(182,245,0)] p-8 sm:p-12 lg:p-16 grid md:grid-cols-[1fr_auto] items-center gap-6"
      >
        {/* decorative stars */}
        <svg
          aria-hidden
          className="absolute -top-10 -right-10 spin-slow opacity-20"
          width="220"
          height="220"
          viewBox="0 0 100 100"
        >
          <path
            d="M50 0 L55 45 L100 50 L55 55 L50 100 L45 55 L0 50 L45 45 Z"
            fill="#000"
          />
        </svg>

        <div className="relative">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight">
            Ready to Build Your <br />
            Dream Website?
          </h2>
          <p className="mt-3 text-black/75 max-w-xl text-base sm:text-lg">
            Let&apos;s work together to create a website that grows your business.
          </p>
        </div>

        <a
          data-testid="cta-start-project-btn"
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="relative inline-flex items-center gap-2 bg-black text-[rgb(182,245,0)] hover:bg-zinc-900 transition-all px-7 py-4 rounded-full font-semibold text-base whitespace-nowrap"
        >
          Start a Project <ArrowRight className="w-4 h-4" />
        </a>
      </motion.div>
    </section>
  );
};
